import Login from '@/pages/Login.vue';
import authenticated from '@/middleware/authenticated';
import guest from '@/middleware/guest';

/** Sends someone who is not signed in to the Academy's own sign-in, and back afterwards. */
function member(to, from, next) {
    return authenticated(to, from, (target) => (target ? next({ name: 'academy.signin', query: target.query }) : next()));
}

/**
 * Deenly Akademija is the study room: Danas, the collection, spaces and
 * topic canvases, all behind an account. Links from before it was only the
 * study room (/akademija/soba/…, courses) land on their place in it.
 */
export default [
    {
        path: '/akademija/prijava',
        name: 'academy.signin',
        component: Login,
        meta: { layout: 'Login', middleware: [guest], academy: true },
    },
    {
        path: '/akademija/registracija',
        name: 'academy.signup',
        component: () => import('@/pages/study/StudySignUp.vue'),
        meta: { layout: 'Login', middleware: [guest] },
    },
    { path: '/akademija/soba/:rest(.*)*', redirect: (to) => `/akademija/${[].concat(to.params.rest ?? []).join('/')}`.replace(/\/$/, '') || '/akademija' },
    { path: '/akademija/:old(danas|kurs|ucim|predajem|certifikat|pravila)/:rest(.*)*', redirect: '/akademija' },
    {
        path: '/akademija',
        component: () => import('@/pages/study/StudyLayout.vue'),
        meta: { layout: 'App', middleware: [member] },
        children: [
            { path: '', name: 'study', component: () => import('@/pages/study/StudyToday.vue') },
            { path: 'zbirka', name: 'study.collection', component: () => import('@/pages/study/StudyCollection.vue') },
            { path: 'prostor/:id(\\d+)', name: 'study.space', component: () => import('@/pages/study/StudySpace.vue') },
            { path: 'tema/:id(\\d+)', name: 'study.topic', component: () => import('@/pages/study/StudyTopic.vue'), meta: { fullscreen: true } },
        ],
    },
];
